export default __webpack_public_path__ + "static/media/check_circle.5cca238a.svg";